module.exports = __webpack_public_path__ + "static/media/virtual-event-tag.34726f72.svg";